import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'unlisted_products-request_cta-click';

/**
 * fires when retailer clicks CTA to open request modal
 */
export function trackUnlistedProductsRequestCtaClick(
  type: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { type },
  });
}
